import { Button, ClickableIcon, HStack, IconCloseSkinny, Text } from '@direct-frontend/components';
import { AdvBannerStrip } from '#shared/ui/AdvBannerStrip';
import { InfoBlock } from '#shared/ui/InfoBlock';
import { type BannerCommunication } from '../../model/selectBannerCommunication';
import { communicationBannerTestIds } from '../../testids';
import styles from './CommunicationBannerView.module.css';

type Props = {
    communication: BannerCommunication;
    onClose: () => void;
    onClick: () => void;
};

export const CommunicationBannerView = ({ communication, onClose, onClick }: Props) => {
    const { text, theme } = communication.details.banner;
    const button = communication.button;

    const action = button ? (
        <Button
            {...(button.url ? { as: 'a', href: button.url, target: '_blank', rel: 'noopener noreferrer' } : {})}
            color="contrast"
            size="xs"
            maxWidth="40%"
            flex="0 0 auto"
            onClick={onClick}
        >
            <span className={styles.buttonText}>{button.text}</span>
        </Button>
    ) : null;

    if (theme === 'error') {
        return (
            <InfoBlock type="icon" color="error" onClose={onClose} data-testid={communicationBannerTestIds.view}>
                <HStack as="span" gap="12" alignItems="center">
                    <span className={styles.text} data-testid={communicationBannerTestIds.text}>
                        {text}
                    </span>
                    {action}
                </HStack>
            </InfoBlock>
        );
    }

    return (
        <AdvBannerStrip type={theme === 'dark_blue' ? 'dark-blue' : undefined}>
            <Text color="strict-white" className={styles.text} data-testid={communicationBannerTestIds.text}>
                {text}
            </Text>
            {action}
            <ClickableIcon
                color={theme === 'dark_blue' ? 'strict-white' : 'white'}
                role="main"
                onClick={onClose}
                title="Закрыть"
                aria-label="Закрыть"
                data-testid={communicationBannerTestIds.close}
            >
                <IconCloseSkinny size="24" />
            </ClickableIcon>
        </AdvBannerStrip>
    );
};
